const getNo = () => {
    this.componentsMoudel.httpRequest
        .getRequestHander(this.componentsMoudel.getData("urls").getReportNo)
        .openLoad()
        .startGet()
        .then(res => {
            // console.log(res)
            res.body.data.forEach((item, index) => {
                this.setNo[index] = item.testReportNo;
            });
        });
}

//获取检修专业
const getProfession = () => {
    this.componentsMoudel.httpRequest
        .getRequestHander(this.componentsMoudel.getData("urls").getProfession)
        .openLoad()
        .startGet()
        .then(res => {
            res.body.data.forEach((item, index) => {
                this.setProfessione[index] = item.name;
            });
        });
}

export {
    getProfession,
    getNo
}